import I18n from "../../../../../../../localization/I18n";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";
import { GridSideModalTitle } from "../../../../utils/GridModalUtils";
import { ImpactLocationsSidebarModel } from "./ImpactLocationsSidebar_model";
import { ImpactLocationsSidebar } from "./ImpactLocationsSidebar_view";

export const IMPACT_LOCATIONS_SIDEBAR_MODAL_CONFIG = (
  organisationId: number,
  projectId: number,
  impact: FP.Entities.IImpact
) => {
  return {
    showClose: true,
    title: <GridSideModalTitle name={impact.name} field={I18n.t("phrases.locations")} />,
    content: (
      <ImpactLocationsSidebar
        model={new ImpactLocationsSidebarModel(ModalContext.hide, organisationId, projectId, impact.id)}
      />
    )
  };
};
